import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import copyToClipboard from "copy-to-clipboard";
import { toast } from "react-toastify";
import { formatDateTimeFromApi } from "../utils/dateTime";
import { getBotConfig } from "../utils/botUtils";
import stringify, { sortObject } from "../utils/stringify";
import AddEditBot from "./AddEditBot";
import { Button, Confirm } from "semantic-ui-react";
import SuspiciousCcysIcon from "./SuspiciousCcysIcon";
import axios from "axios";
import { getAuthHttpHeaders } from "../auth";

@inject("store")
@observer
export default class BotConfig extends Component {
  state = {
    editing: false,
    confirmDeleteShown: false,
  };

  onBotEdited = () => {
    this.setState({ editing: false });
    if (this.props.onRefresh) this.props.onRefresh();
  };

  confirmDelete = () => {
    this.setState({ confirmDeleteShown: true });
  };

  denyDelete = () => {
    this.setState({ confirmDeleteShown: false });
  };

  botDeleted = () => {
    this.setState({ botDeleted: true });
    if (this.props.onRefresh) this.props.onRefresh();
  };

  deleteBot = async (botId, successCallback) => {
    let axiosRequest = axios.create({
      baseURL: "api",
      timeout: 30 * 1000,
      headers: {
        Accept: "application/json",
        ...getAuthHttpHeaders(),
      },
    });

    try {
      await axiosRequest.delete("botInstance/" + botId);
    } catch (e) {
      alert(e);
      return;
    }

    successCallback();
  };

  copyToClipboard = () => {
    copyToClipboard(stringify(sortObject(getBotConfig(this.props.botInstance))));
    toast.info("Bot config " + this.props.botInstance.id + " copied");
  };

  render() {
    const {
      store: { zoneId },
      botInstance: bi,
      editable,
      editing,
      usedSuspiciousCcys,
    } = this.props;

    const config = getBotConfig(bi);

    const copyToClipboard = (
      <Button size="mini" icon="copy" onClick={this.copyToClipboard} style={{ marginLeft: "20px" }} />
    );

    const editButton = editable ? (
      <Button
        size="mini"
        icon="pencil alternate"
        onClick={() => this.setState({ editing: !this.state.editing })}
        toggle
        style={{ marginLeft: "5px" }}
      />
    ) : null;

    const deleteButton =
      editable && !editing ? (
        <Button size="mini" icon="trash alternate" onClick={this.confirmDelete} style={{ marginLeft: "5px" }} />
      ) : null;

    let suspiciousWarningMsg;
    if (usedSuspiciousCcys && usedSuspiciousCcys.length > 0) {
      suspiciousWarningMsg = (
        <div style={{ color: "red" }}>
          <SuspiciousCcysIcon usedSuspiciousCcys={usedSuspiciousCcys} /> Suspicious currencies used:{" "}
          {usedSuspiciousCcys.join()}
        </div>
      );
    }

    const readContent = (
      <div>
        {suspiciousWarningMsg}
        Created: {formatDateTimeFromApi(bi.createdAt, zoneId)}
        {copyToClipboard}
        {editButton}
        {deleteButton}
        <pre style={{ whiteSpace: "pre-wrap" }}>{stringify(sortObject(config))}</pre>
      </div>
    );

    let content;
    if (this.state.botDeleted) {
      content = (
        <div className="ui warning message">
          <div className="header">The bot has been deleted!</div>
        </div>
      );
    } else if (this.state.editing) {
      content = (
        <AddEditBot
          key={bi.id}
          config={stringify(config)}
          edit
          editBotId={bi.id}
          botType={bi.type}
          enabled={bi.enabled}
          period={bi.period}
          onSuccess={this.onBotEdited}
          onClose={() => this.setState({ editing: false })}
        />
      );
    } else {
      content = (
        <div>
          {readContent}

          <Confirm
            open={this.state.confirmDeleteShown}
            content={"Are you sure you want to remove bot with ID: " + bi.id + " ?"}
            onCancel={this.denyDelete}
            onConfirm={() => this.deleteBot(bi.id, this.botDeleted)}
          />
        </div>
      );
    }

    return content;
  }
}



// WEBPACK FOOTER //
// ./src/bot/BotConfig.js